import React from "react";
import "../styles/categoryGrid.css";

/* ── thumbnail helper (unchanged from original) ── */
const getCatThumbnailUrl = (originalUrl) => {
  if (!originalUrl) return originalUrl;
  const url = originalUrl.replace("/category/", "/cat-thumbnails/");
  const lastDot = url.lastIndexOf(".");
  if (lastDot === -1) return url;
  return url.substring(0, lastDot) + ".webp";
};

/* ── sort helper (unchanged from original) ── */
const sortCategories = (categories) =>
  [...categories].sort((a, b) => {
    const getOrder = (val) => {
      if (val === null || val === undefined || val === "") return 9999;
      const num = Number(val);
      return isNaN(num) ? 9999 : num;
    };
    const diff = getOrder(a.order) - getOrder(b.order);
    if (diff !== 0) return diff;
    return (a.category_name || "").localeCompare(b.category_name || "");
  });

const CategoryGrid = ({ categories, onCategoryClick, selectedCat }) => {
  const sorted = sortCategories(categories);

  /* Skeleton while categories haven't loaded yet */
  if (!sorted.length) {
    return (
      <section className="category-strip" aria-label="Shop by category">
        <div className="category-strip-header">
          <h2 className="category-strip-title">Shop by Collection</h2>
        </div>
        <div className="category-strip-rail-wrap">
          <div className="category-rail" role="list">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="category-card-skeleton" role="listitem">
                <div className="skel-circle" />
                <div className="skel-label" />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="category-strip" aria-label="Shop by category">
      {/* Header */}
      <div className="category-strip-header">
        <h2 className="category-strip-title">Shop by Collection</h2>
        <span className="category-strip-count">{sorted.length} categories</span>
      </div>

      {/* Horizontal rail */}
      <div className="category-strip-rail-wrap">
        <div
          className="category-rail"
          role="list"
          /* Native scroll — no JS needed for 90Hz smoothness */
        >
          {sorted.map((cat) => {
            const isActive = selectedCat === cat.id;
            return (
              <button
                key={cat.id}
                className={`category-card${isActive ? " active" : ""}`}
                onClick={() => onCategoryClick(cat.id)}
                aria-pressed={isActive}
                aria-label={cat.category_name}
                type="button"
              >
                {/* Circle image */}
                <div className="category-img-wrap">
                  <img
                    src={getCatThumbnailUrl(cat.category_image)}
                    alt={cat.category_name}
                    className="category-img"
                    loading="lazy"
                    decoding="async"
                    onError={(e) => {
                      if (e.target.src !== cat.category_image)
                        e.target.src = cat.category_image;
                    }}
                  />
                </div>

                {/* Label */}
                <span className="category-label">{cat.category_name}</span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;